<template>
  <div class="filter-review">
    <div class="filter-review__header" :class="{ unwrapped: !wrappedFilter }">
      <template v-if="wrappedFilter">
        <ul v-if="tabs && tabs.length">
          <li v-if="!is_desktop && count > 0" class="filter-button" @click="showFilter = !showFilter">
            <img
              :src="
                hasValue && !is_default_filter
                  ? '/assets/img/icon-filter-revamp-active.svg'
                  : '/assets/img/icon-filter-revamp.svg'
              "
              width="12"
              height="13"
            />
          </li>
          <li
            v-for="(item, index) in tabs"
            :key="index + '-filter-tabs'"
            :class="{ active: item.value === filter.tabName }"
            @click="$emit('changeTab', item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div
          v-if="filterData && filterData.length && is_desktop && count > 0"
          class="filter-review__header__filter"
          @click="showFilter = !showFilter"
        >
          <img
            :src="
              hasValue && !is_default_filter
                ? '/assets/img/icon-filter-revamp-active.svg'
                : '/assets/img/icon-filter-revamp.svg'
            "
            width="12"
            height="13"
          />
          <span>{{ hasValue && !is_default_filter ? 'Filtered' : 'Filter' }}</span>
        </div>
        <div v-if="showFilter" id="new-filter-review" class="filter-list">
          <div v-if="!is_desktop" class="filter-list__header">
            <p class="filter-list__header__left">
              <a href="" @click.prevent="showFilter = !showFilter">
                <SvgImg
                  name="back-header-icon"
                  width="22"
                  height="16"
                  alt="back-icon"
                  @click="showFilter = !showFilter"
                />
              </a>
              <span>Filter</span>
            </p>
            <p v-if="hasValue && !is_default_filter" class="filter-list__header__right" @click="reset">Reset filter</p>
          </div>
          <div class="filter-list__wrap">
            <div v-for="(item, index) in filterData" :key="index + '-filter'" class="filter-list__item">
              <h4 v-if="item.title">{{ item.title }}</h4>
              <ul v-if="item.filter">
                <template v-if="item.data === 'rating'">
                  <li
                    v-for="(item2, index2) in item.filter"
                    :key="index2 + '-filter-item'"
                    class="star-rating"
                    :class="{ active: isActive(item2.value, item) }"
                    @click="filtered(item2.value, item)"
                    v-html="item2.name + '&nbsp;' + item2.value"
                  />
                </template>
                <template v-else>
                  <li
                    v-for="(item2, index2) in item.filter"
                    :key="index2 + '-filter-item'"
                    :class="{ active: isActive(item2.value, item) }"
                    @click="filtered(item2.value, item)"
                  >
                    {{ item2.name }}
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="filter-list__action">
            <p v-if="is_desktop && hasValue && !is_default_filter" class="reset" @click="reset">Reset filter</p>
            <p :class="{ disabled: !isFilterChanged }" class="submit" @click="submit">Apply filter</p>
          </div>
        </div>
      </template>
      <template v-else>
        <ul v-if="tabs && tabs.length">
          <li
            v-for="(item, index) in tabs"
            :key="index + '-filter-tabs'"
            :class="{ active: item.value === filter.tabName }"
            @click="$emit('changeTab', item)"
          >
            <img
              v-if="item.value === 'trusted-review'"
              :src="`/assets/img/expert-review/shopper-review-${filter.tabName === item.value ? 'pink' : 'gray'}.svg`"
              height="15"
              width="15"
            />
            <img
              v-else-if="item.value === 'expert-review'"
              :src="`/assets/img/expert-review/expert-review-${filter.tabName === item.value ? 'pink' : 'gray'}.svg`"
              height="14"
              width="16"
            />
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </template>
    </div>
    <div v-if="!wrappedFilter && tabs && tabs.length" class="filter-review__pills">
      <ul v-if="pillsFilterLoading" class="element-placeholder">
        <li v-for="i in 5" :key="i" class="placeholder" style="height: 30px; width: 111px"></li>
      </ul>
      <ul v-else>
        <li v-if="isFiltered" @click="resetPillFilter()">
          <div class="filter-review__pills--pill">
            <img src="/assets/img/icon-close.svg" height="11" width="11" />
          </div>
        </li>
        <li v-for="(filter, index) in allPillsFilter" :key="index">
          <template v-if="filter.key">
            <div
              class="filter-review__pills--pill"
              :class="{ active: isPillActive(filter) }"
              @click="showPillDropdown(filter.key)"
            >
              <span
                v-if="filter.key === 'combinations'"
                v-html="$SO.isEmptyObject(selected[filter.key]) ? filter.title : getSelectedFilterLabel(filter)"
              ></span>
              <span v-else>
                {{
                  $SO.isEmptyObject(selected[filter.key])
                    ? filter.title
                    : selected[filter.key]
                    ? getSelectedFilterLabel(filter)
                    : ''
                }}
              </span>
              <img v-if="isPillActive(filter)" src="/assets/img/chevron_down_white.svg" />
              <img v-else src="/assets/img/chevron_down_red.svg" />
            </div>
            <ul v-if="show[filter.key] && is_desktop" class="filter-review__pills--dropdown">
              <li v-if="filter.key !== 'sort'" @click="selectPillDropdown(filter.key, '')">
                <p>
                  <span>{{ filter.title }}</span>
                </p>
              </li>
              <li
                v-for="(list, index) in filter.list"
                :key="index"
                @click="!list.subtags ? selectPillDropdown(filter.key, list) : ''"
              >
                <div v-if="filter.key === 'rating'" class="rate-star--uniform">
                  <span v-for="value in list.value" :key="`pink-${value}`"></span>
                  <i v-for="i in 5 - list.value" :key="`gray-${i}`" class="icon_star"></i>
                </div>
                <p
                  v-else
                  :class="{ 'has-subtags': list.subtags, expanded: list.subtags_expanded }"
                  @click="list.subtags_expanded = !list.subtags_expanded"
                >
                  <span v-if="filter.key === 'combinations'" class="shade-combination" v-html="list.name"></span>
                  <span v-else>{{ list.name }}</span>
                  <img v-if="list.subtags" src="/assets/img/chevron_down_red.svg" />
                </p>
                <ul v-if="list.subtags" :class="['subtags', { expanded: list.subtags_expanded }]">
                  <li v-for="(subtag, index) in list.subtags" :key="index">
                    <p>
                      <input
                        :id="subtag.id"
                        type="checkbox"
                        class="checkbox"
                        :name="list.name"
                        height="16"
                        width="16"
                        :value="subtag.id"
                        :checked="selected['concern'].includes(subtag.id)"
                        @input="concernCheck(subtag)"
                      />
                      <label :for="subtag.id">{{ subtag.name }}</label>
                    </p>
                  </li>
                </ul>
              </li>
              <li v-if="filter.key === 'concern'" class="apply-button">
                <button class="btn red" @click="applyConcern()">Apply</button>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </div>
    <div
      v-if="!wrappedFilter && ((!isFiltered && tabs && tabs.length) || (isFiltered && count))"
      class="filter-review__personalized"
    >
      <template v-if="filter.tabName !== 'review-with-photos'">
        <template v-if="showRelevantReviews || (is_loggedin && !isBeautyProfileCompleted) || !is_loggedin">
          <div v-if="showRelevantReviews" class="filter-review__personalized--login-and-complete-bp">
            <div v-if="is_desktop" class="filter-review__personalized__edit-link">
              <!-- BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072 -->
            </div>
            <div
              v-else
              class="filter-review__personalized__edit-link--mobile"
              :class="{ hide: !is_desktop && scrollPosition > 200 }"
            >
              <!-- BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072 -->
            </div>
            <user-beauty-tags v-if="!isOpenModalSeeMoreReviews" :product="product"></user-beauty-tags>
          </div>
          <div v-else class="filter-review__personalized--not-complete-bp">
            <!-- BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072 -->
            <p v-if="!is_loggedin">
              Login / Register untuk mendapatkan review yang lebih relevan dengan beauty profile kamu.
              <a href="" @click.prevent="loginOtf">Login sekarang</a>
            </p>
          </div>
        </template>
      </template>
      <div v-if="showExpertInfo" class="filter-review__personalized--trusted-review">
        <img src="/assets/img/expert-review/expert-review-pink.svg" height="13" width="14" />
        <p>
          <span> Expert Review</span> adalah review yang ditulis langsung oleh Expert pada bidangnya, terdetail dan
          teruji untuk beragam beauty profile.<br />
          <a href="" @click.prevent="hideTabInfo('expert-info')">Ok, saya mengerti</a>
        </p>
      </div>
      <div v-if="showShopperInfo" class="filter-review__personalized--trusted-review">
        <img src="/assets/img/expert-review/shopper-review-pink.svg" height="12" width="12" />
        <p>
          <span> Shopper Review</span> adalah review dari user yang membeli produk kecantikan di Sociolla atau
          mendapatkan produk kecantikan dari program sampling kami<br />
          <a href="" @click.prevent="hideTabInfo('shopper-info')">Ok, saya mengerti</a>
        </p>
      </div>
    </div>
    <div v-if="combinations.length > 1 && wrappedFilter" id="review-pdp-filter-review" class="filter-review__detail">
      <div v-if="is_desktop" class="filter-review__detail__title">Combination</div>
      <ul>
        <template v-for="(comb, index) in combinations">
          <li
            v-if="comb.is_active_in_review"
            :key="index + '-combination-item'"
            :class="{ 'shade-only': isShadeOnly(comb), active: isActive(comb.id, { data: 'combinations' }) }"
            @click="filtered(comb.id, { data: 'combinations' }, true)"
          >
            <template v-if="isShadeOnly(comb)">
              <img
                v-if="isImage(comb.attributes[0].value)"
                :src="comb.attributes[0].value"
                width="26"
                height="26"
                class="rounded-image"
                @error="imageErrorHandler($event)"
              />
              <button v-else :style="`width:26px;height:26px;background:${comb.attributes[0].value}`" />
            </template>
            <template v-else>
              <template v-for="(attr, index2) in comb.attributes">
                <template v-if="attr.type === 'shade'">
                  <img
                    v-if="isImage(attr.value)"
                    :key="index2 + '-attr-item-image'"
                    :src="attr.value"
                    width="16"
                    height="16"
                    class="rounded-image"
                    @error="imageErrorHandler($event)"
                  />
                  <button
                    v-else
                    :key="index2 + '-attr-item'"
                    :style="`width:16px;height:16px;background:${attr.value}`"
                  />
                </template>
                <template v-else>
                  {{ attr.name }}
                </template>
                <span v-if="index2 + 1 < comb.attributes.length" :key="index2 + '-attr-item-space'" class="space">
                  -
                </span>
              </template>
            </template>
          </li>
        </template>
      </ul>
    </div>
    <!-- filter dropdown modal for mobile -->
    <g-modal
      v-if="!is_desktop && openedFilter && show[openedFilter]"
      id="pills-dropdown-mobile"
      class="normalize-gutter"
    >
      <template slot="header">
        <div class="rectangle-top"></div>
        <div class="modal-heading">
          <h4 class="modal-heading--title">{{ getTitle }}</h4>
          <button
            type="button"
            class="close modal-heading--close"
            data-dismiss="modal"
            aria-label="Close"
            @click="
              openedFilter = '';
              show[openedFilter] = false;
            "
          >
            <img src="/assets/img/icon-close.svg" height="14" width="14" />
          </button>
        </div>
      </template>
      <template slot="body">
        <ul v-if="show[openedFilter] && openedFilter && getOpenedFilterList" class="pills-dropdown-mobile--list">
          <li
            v-if="openedFilter !== 'sort'"
            :class="{
              active: Array.isArray(selected[getOpenedFilterList.key])
                ? !selected[getOpenedFilterList.key].length
                : !selected[getOpenedFilterList.key],
            }"
            @click="selectPillDropdown(openedFilter, '')"
          >
            <p>
              <span>{{ getOpenedFilterList.title }}</span>
            </p>
          </li>
          <li
            v-for="(list, index) in getOpenedFilterList.list"
            :key="index"
            :class="{ active: isActiveMobileFilter(list), 'has-subtags': list.subtags }"
            @click="!list.subtags ? selectPillDropdown(openedFilter, list) : ''"
          >
            <div v-if="openedFilter === 'rating'" class="rate-star--uniform">
              <span v-for="value in list.value" :key="`pink-${value}`"></span>
              <i v-for="i in 5 - list.value" :key="`gray-${i}`" class="icon_star"></i>
            </div>
            <p
              v-else
              :class="{ 'has-subtags': list.subtags, expanded: list.subtags_expanded }"
              @click="list.subtags_expanded = !list.subtags_expanded"
            >
              <span v-if="openedFilter === 'combinations'" class="shade-combination" v-html="list.name"></span>
              <span v-else>{{ list.name }}</span>
              <img v-if="list.subtags" src="/assets/img/chevron_down_red.svg" height="9" width="16" />
            </p>
            <ul v-if="list.subtags" :class="['subtags', { expanded: list.subtags_expanded }]">
              <li v-for="(subtag, index) in list.subtags" :key="index">
                <p>
                  <label :for="subtag.id">{{ subtag.name }}</label>
                  <input
                    :id="subtag.id"
                    type="checkbox"
                    class="checkbox"
                    :name="list.name"
                    height="16"
                    width="16"
                    :value="subtag.id"
                    :checked="selected['concern'].includes(subtag.id)"
                    @input="concernCheck(subtag)"
                  />
                </p>
              </li>
            </ul>
          </li>
          <li v-if="openedFilter === 'concern'" class="apply-button">
            <button class="btn red" @click="applyConcern()">APPLY</button>
          </li>
        </ul>
      </template>
    </g-modal>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
import startCase from 'lodash.startcase';
export default {
  name: 'FilterReview',
  components: {
    UserBeautyTags: () => import('@/components/product/product-detail/snippet/user-beauty-tags'),
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
      required: true,
    },
    filter: {
      type: Object,
      default: () => {},
      required: true,
    },
    product: {
      type: Object,
      default: () => {},
      required: true,
    },
    count: {
      type: Number,
      default: 0,
      required: true,
    },
    initial: {
      type: Boolean,
      default: true,
      required: true,
    },
    wrappedFilter: {
      type: Boolean,
      default: true,
      required: false,
    },
    reviews: {
      default: () => [],
      required: false,
    },
    scrollPosition: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data() {
    return {
      // Filter Data
      helpful: {
        title: '',
        filter: [{ name: 'Most Helpful', value: '-total_likes' }],
      },
      order: {
        title: 'Order by',
        select: true,
        filter: [
          { name: 'Newest', value: '-created_at' },
          { name: 'Oldest', value: 'created_at' },
        ],
      },
      rating: {
        title: 'Rating',
        filter: [
          {
            name: '<i class="icon_star"></i><i class="icon_star"></i><i class="icon_star"></i><i class="icon_star"></i><i class="icon_star"></i>',
            value: 5,
          },
          {
            name: '<i class="icon_star"></i><i class="icon_star"></i><i class="icon_star"></i><i class="icon_star"></i>',
            value: 4,
          },
          { name: '<i class="icon_star"></i><i class="icon_star"></i><i class="icon_star"></i>', value: 3 },
          { name: '<i class="icon_star"></i><i class="icon_star"></i>', value: 2 },
          { name: '<i class="icon_star"></i>', value: 1 },
        ],
      },
      age: {
        title: 'Age group',
        filter: [
          { name: '< 18 th', value: '< 18 th' },
          { name: '19 - 24 th', value: '19 - 24 th' },
          { name: '25 - 29 th', value: '25 - 29 th' },
          { name: '30 - 34 th', value: '30 - 34 th' },
          { name: '35 - 39 th', value: '35 - 39 th' },
          { name: '> 40 th', value: '> 40 th' },
        ],
      },
      concernFilter: [],
      filterData: [],
      isFilterChanged: false,
      showFilter: false,
      isSubmited: false,
      newFilter: {},
      selected: {
        combinations: [],
        sort: '',
        concern: [],
        rating: '',
        age: '',
      },
      concernName: [],
      show: {
        sort: false,
        concern: false,
        combinations: false,
        rating: false,
        age: false,
      },
      pillsFilterLoading: true,
      userSelectingConcern: false,
      tours: [
        {
          title: 'Ada yang baru nih!',
          content: '<p>Sekarang kamu bisa memfilter review berdasarkan product combination.</p>',
          arrow: 'bottom-left',
          arrow_mobile: 'bottom-left',
          position: 'top',
          id: 'review-pdp-filter-review',
          index: 0,
          next_title: 'OK',
          style: 'transform:translate(-50%, 0);left:50%;width:260px;padding:12px;',
          coachmark: 'review_pdp_filter_review',
          scroll: true,
          overlay: true,
        },
      ],
      openedFilter: '',
      hideExpertInfo: false,
      hideShopperInfo: false,
    };
  },
  computed: {
    showExpertInfo() {
      return this.filter.tabName === 'expert-review' &&
        !this.hideExpertInfo &&
        !this.getCookieExpertInfo &&
        this.tabs.length &&
        Number(this.tabs[1].count) > 0
        ? true
        : false;
    },
    showShopperInfo() {
      return this.filter.tabName === 'trusted-review' &&
        !this.hideShopperInfo &&
        !this.getCookieShopperInfo &&
        this.tabs.length &&
        Number(this.tabs[2].count) > 0
        ? true
        : false;
    },
    getCookieExpertInfo() {
      return document.cookie.indexOf('expert-info') > -1 ? true : false;
    },
    getCookieShopperInfo() {
      return document.cookie.indexOf('shopper-info') > -1 ? true : false;
    },
    hasValue() {
      let res = false;
      if (Object.entries(this.selected).length) {
        res = this.checkValue(this.selected);
      }
      return res;
    },
    combinations() {
      const comb = [];
      if (this.product && Object.entries(this.product).length) {
        this.product.combinations.forEach((c) => {
          if (c.is_active_in_review && c.attributes && Object.entries(c.attributes).length) {
            const data = { id: c._id, is_active_in_review: c.is_active_in_review, attributes: [] };
            for (const [key, value] of Object.entries(c.attributes)) {
              const obj = {
                name: value.name,
                value: value.value,
                type: key,
                id: value.id,
              };
              if (key === 'shade') {
                data.attributes.unshift(obj);
              } else {
                data.attributes.push(obj);
              }
            }
            comb.push(data);
          }
        });
      }
      if (comb.length > 1 && this.count > 0) {
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(() => {
          this.$store.commit('setTours', this.tours);
          this.$store.dispatch('showTour', {
            index: 0,
            cookie: 'review_pdp_filter_review',
            coachmark: 'review_pdp_filter_review',
          });
        }, 100);
      }
      return comb;
    },
    is_desktop() {
      return this.$store.state.screen.isDesktop;
    },
    is_loggedin() {
      return this.$store.state.auth.loggedin;
    },
    is_default_filter() {
      let def = false;
      const filter = JSON.parse(JSON.stringify(this.selected));
      // default filter is most likes
      def = Boolean(this.selected['helpful'].length);
      delete filter['helpful'];
      return def && this.initial && !this.checkValue(filter);
    },
    combinationsFilter() {
      const { combinations, isShadeOnly, isSizeOnly, isVariantOnly, isImage } = this;
      let combinationsTitle = 'combinations';
      const combinationsFilterList = [];

      for (const combination of combinations) {
        if (isShadeOnly(combination)) {
          combinationsTitle = 'shades';
        } else if (isSizeOnly(combination)) {
          combinationsTitle = 'size';
        } else if (isVariantOnly(combination)) {
          combinationsTitle = 'variants';
        }
        if (
          !Boolean(
            combination.attributes &&
              combination.attributes.length === 1 &&
              combination.attributes[0] &&
              combination.attributes[0].type &&
              combination.attributes[0].type === 'non_specify'
          )
        ) {
          combinationsFilterList.push({
            name: combination.attributes
              .reduce((result, attribute) => {
                if (attribute.type === 'shade') {
                  if (isImage(attribute.value)) {
                    result.unshift(
                      `<img src="${
                        attribute.value || '/assets/img/dummy-combination.png'
                      }" width="16" height="16" class="shade-combination--image" onerror="this.src='/assets/img/dummy-combination.png'"><span>${
                        attribute.name
                      }</span>`
                    );
                  } else {
                    result.unshift(
                      `<div class="shade-combination--image" style="background:${attribute.value}"></div><span>${attribute.name}</span>`
                    );
                  }
                } else {
                  result.push(attribute.name);
                }
                return result;
              }, [])
              .join(' - '),
            value: combination.id,
          });
        }
      }
      return {
        title: `All ${startCase(combinationsTitle)}`,
        list: combinationsFilterList,
        key: 'combinations',
      };
    },
    ageFilter() {
      const { age } = this;
      return {
        title: `All ${startCase(age.title)}`,
        list: age.filter,
        key: 'age',
      };
    },
    ratingFilter() {
      const { rating } = this;
      return {
        title: `All ${startCase(rating.title)}`,
        list: rating.filter.map((rating) => {
          return {
            name: `Rating ${rating.value}`,
            value: rating.value,
          };
        }),
        key: 'rating',
      };
    },
    sortFilter() {
      const list = [
        {
          name: 'Most Helpful',
          value: '-total_likes',
        },
        {
          name: 'Newest',
          value: '-created_at',
        },
        {
          name: 'Oldest',
          value: 'created_at',
        },
      ];
      if (this.isBeautyProfileCompleted) {
        list.unshift({
          name: 'Most Relevant',
          value: 'most_relevant',
        });
      }
      return {
        title: list[0].name,
        key: 'sort',
        list: list,
      };
    },
    allPillsFilter() {
      return [this.sortFilter, this.concernFilter, this.combinationsFilter, this.ratingFilter, this.ageFilter];
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    userSkinType() {
      return this.user.beauty.reduce((result, beauty) => {
        if (beauty.name === 'jenis-kulit' || beauty.name === 'kondisi-kulit') {
          result = [...result, ...beauty.subtags];
        }
        return result;
      }, []);
    },
    userHairType() {
      return this.user.beauty.reduce((result, beauty) => {
        if (beauty.name.includes('rambut')) {
          result = [...result, ...beauty.subtags];
        }
        return result;
      }, []);
    },
    isRelevantSkinType() {
      return this.userSkinType.some((skin) => {
        if (
          this.reviews &&
          this.reviews[0] &&
          this.reviews[0].user &&
          this.reviews[0].user.skin_types &&
          this.reviews[0].user.skin_types.length
        ) {
          return Boolean(this.reviews[0].user.skin_types.some((type) => type._id === skin._id));
        }
      });
    },
    isRelevantHairType() {
      return this.userHairType.some((hair) => {
        if (
          this.reviews &&
          this.reviews[0] &&
          this.reviews[0].user &&
          this.reviews[0].user.hair_types &&
          this.reviews[0].user.hair_types.length
        ) {
          return Boolean(this.reviews[0].user.hair_types.some((type) => type._id === hair._id));
        }
      });
    },
    showRelevantReviews() {
      const registrationDate = dayjs(this.user.created_at);
      const now = dayjs(new Date());
      return this.is_loggedin && this.isBeautyProfileCompleted && now.diff(registrationDate, 'month') > 3;
    },
    isOpenModalSeeMoreReviews() {
      return this.$store.state.productDetail.isOpenModalSeeMoreReviews;
    },
    isBeautyProfileCompleted() {
      const { user } = this;
      return (
        user &&
        user.beauty &&
        user.beauty.length &&
        !this.$SO.isEmptyObject(user.beauty.find((beauty) => beauty.type === 'beauty-profile'))
      );
    },
    beautyProfile() {
      return this.$store.state.auth.userProfile.beauty;
    },
    isFiltered() {
      return Object.keys(this.selected)
        .filter((key) => key !== 'helpful')
        .some((key) => {
          if (key === 'concern') {
            return !this.$SO.isEmptyObject(this.selected[key]) && !this.userSelectingConcern;
          } else {
            return !this.$SO.isEmptyObject(this.selected[key]);
          }
        });
    },
    getTitle() {
      switch (this.openedFilter) {
        case 'sort':
          return 'sort by';
        case 'combinations':
          return 'filter by combination';
        case 'age':
          return 'age group';
        default:
          return this.openedFilter;
      }
    },
    getOpenedFilterList() {
      return this.allPillsFilter.find((pill) => pill.key === this.openedFilter);
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(newVal) {
        if (newVal && Object.entries(newVal).length && !this.filterData.length) {
          this.setData(newVal);
        }
      },
    },
    showFilter(newVal) {
      if (newVal === true) {
        if (!this.is_desktop) {
          this.$SO('body').addClass('no-scroll');
        }
        this.isSubmited = false;
      } else if (newVal === false) {
        if (!this.is_desktop) {
          this.$SO('body').removeClass('no-scroll');
        }
        if (!this.isSubmited) {
          this.setData(this.options, false);
        }
      }
    },
    selected: {
      deep: true,
      handler(newVal) {
        let changed = false;
        if (Object.entries(newVal).length) {
          for (const [key, value] of Object.entries(newVal)) {
            if (Array.isArray(value)) {
              const data = this.filter[key] || [];
              changed = Boolean(data.length !== value.length);
              if (!changed) {
                changed = Boolean(data.filter((x) => value.includes(x)).length !== value.length);
              }
            } else {
              const data = this.filter[key] || '';
              changed = Boolean(data !== value);
            }
            if (changed) {
              break;
            }
          }
        }
        this.isFilterChanged = changed;
        if (!this.wrappedFilter && !this.userSelectingConcern) {
          this.submit();
        }
      },
    },
    product: {
      immediate: true,
      handler(product) {
        if (product) {
          this.fetchBeautyTags();
        }
      },
    },
    'filter.combinations': {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.selected.combinations = newValue;
        }
      },
    },
  },
  created() {
    document.addEventListener('click', this.clicked);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clicked);
  },
  methods: {
    hideTabInfo(name) {
      if (name === 'expert-info') {
        this.hideExpertInfo = true;
      }
      if (name === 'shopper-info') {
        this.hideShopperInfo = true;
      }
      this.$store.dispatch('setCookie', { name, value: true });
    },
    filtered(value, item, submit = false) {
      const copy = JSON.parse(JSON.stringify(this.selected));
      if (item.select) {
        copy[item.data] = copy[item.data] !== value ? value : '';
      } else {
        const check = copy[item.data].indexOf(value);
        if (check > -1) {
          copy[item.data].splice(check, 1);
        } else {
          copy[item.data].push(value);
        }
      }
      this.selected = Object.assign({}, { ...copy });
      if (submit) {
        this.submit();
      }
    },
    setData(options, reset = true) {
      let data = { ...this.options };
      if (options) {
        data = { ...options };
      }
      if (reset) {
        this.filterData = [];
      }
      for (const [key, value] of Object.entries(data)) {
        let data = this[key];
        let val = null;
        if (reset) {
          if (!data) {
            data = {
              title: value.title,
              filter: value.filter,
            };
          }
          data['data'] = key;
          this.filterData.push(data);
        }
        if (data && data.select) {
          val = this.filter[key] || '';
        } else {
          val = this.filter[key] || [];
        }
        this.selected[key] = val;
      }
    },
    isActive(value, item) {
      if (item.select) {
        if (item.data === 'helpful') {
          return this.selected[item.data].indexOf(value) > -1;
        } else {
          return this.selected[item.data] === value;
        }
      } else {
        return this.selected[item.data].indexOf(value) > -1;
      }
    },
    isShadeOnly(comb) {
      return comb.attributes.length === 1 && comb.attributes[0].type === 'shade';
    },
    isSizeOnly(comb) {
      return comb.attributes.length === 1 && comb.attributes[0].type === 'size';
    },
    isVariantOnly(comb) {
      return comb.attributes.length === 1 && comb.attributes[0].type === 'variant';
    },
    clicked(e) {
      if (
        !e.target.closest('#new-filter-review') &&
        !e.target.closest('.filter-button') &&
        !e.target.closest('.filter-review__header__filter') &&
        this.showFilter
      ) {
        this.showFilter = false;
      }
    },
    submit() {
      const sel = { ...this.selected };
      const age = [];
      if (sel.age && sel.age.length) {
        sel.age.forEach((x) => {
          let birthdate;
          let gteRangeDate;
          let lteRangeDate = '';
          if (x === '< 18 th') {
            gteRangeDate = dayjs(new Date()).subtract(18, 'years');
            gteRangeDate = gteRangeDate.toISOString();
            birthdate = { $gte: `${gteRangeDate}` };
          } else if (x === '19 - 24 th') {
            gteRangeDate = dayjs(new Date()).subtract(24, 'years');
            gteRangeDate = gteRangeDate.toISOString();
            lteRangeDate = dayjs(new Date()).subtract(19, 'years');
            lteRangeDate = lteRangeDate.toISOString();
            birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
          } else if (x === '25 - 29 th') {
            gteRangeDate = dayjs(new Date()).subtract(29, 'years');
            gteRangeDate = gteRangeDate.toISOString();
            lteRangeDate = dayjs(new Date()).subtract(25, 'years');
            lteRangeDate = lteRangeDate.toISOString();
            birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
          } else if (x === '30 - 34 th') {
            gteRangeDate = dayjs(new Date()).subtract(34, 'years');
            gteRangeDate = gteRangeDate.toISOString();
            lteRangeDate = dayjs(new Date()).subtract(30, 'years');
            lteRangeDate = lteRangeDate.toISOString();
            birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
          } else if (x === '35 - 39 th') {
            gteRangeDate = dayjs(new Date()).subtract(39, 'years');
            gteRangeDate = gteRangeDate.toISOString();
            lteRangeDate = dayjs(new Date()).subtract(35, 'years');
            lteRangeDate = lteRangeDate.toISOString();
            birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
          } else if (x == '> 40 th') {
            lteRangeDate = dayjs(new Date()).subtract(40, 'years');
            lteRangeDate = lteRangeDate.toISOString();
            birthdate = { $lte: `${lteRangeDate}` };
          }
          if (birthdate) {
            age.push({ 'user.birthday_date': birthdate });
          }
          // age.push({ 'user.age_range': x });
        });
      }
      sel['valueAge'] = age;
      sel['tabName'] = this.filter.tabName;
      this.isSubmited = true;
      this.showFilter = false;
      this.isFilterChanged = false;
      this.$emit('submit', sel);
    },
    reset(emit = true) {
      const sel = { ...this.selected };
      if (Object.entries(sel).length) {
        for (const [key, value] of Object.entries(sel)) {
          if (Array.isArray(value)) {
            this.selected[key] = [];
          } else {
            this.selected[key] = '';
          }
        }
      }
      this.showFilter = false;
      if (emit) {
        this.$emit('reset');
      }
    },
    checkValue(data) {
      let res = false;
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
          if (value.length) {
            res = true;
          }
        } else {
          if (value) {
            res = true;
          }
        }
      }
      return res;
    },
    isImage(value) {
      if (value && value.search('#') !== -1 && value.length <= 7) {
        return false;
      } else {
        return true;
      }
    },
    imageErrorHandler(e) {
      e.target.src = '/assets/img/dummy-combination.png';
    },
    showPillDropdown(pill) {
      for (const key of Object.keys(this.show)) {
        if (this.show[key] === true && key !== pill) {
          this.show[key] = false;
        }
      }
      if (!this.is_desktop && !this.show[pill]) {
        this.openedFilter = pill;
      }
      this.show[pill] = !this.show[pill];
    },
    selectPillDropdown(key, filter) {
      if (!filter) {
        this.selected[key] = Array.isArray(this.selected[key]) ? [] : '';
        if (key === 'concern') {
          this.concernName = [];
        }
      } else {
        if (['rating', 'age', 'combinations'].includes(key)) {
          this.selected[key] = [filter.value];
        } else {
          this.selected[key] = filter;
        }
      }
      this.showPillDropdown(key);
    },
    resetPillFilter() {
      for (const filter of Object.keys(this.selected)) {
        if (['combinations', 'concern'].includes(filter)) {
          this.selected[filter] = [];
          if (filter === 'concern') {
            this.concernName = [];
          }
        } else {
          this.selected[filter] = '';
        }
        this.show[filter] = false;
      }
    },
    concernCheck(subtag) {
      if (subtag) {
        this.userSelectingConcern = true;
        const selectedConcernIndex = this.selected.concern.indexOf(subtag.id);
        const selectedConcernNameIndex = this.concernName.indexOf(subtag.name);
        if (selectedConcernIndex > -1 && selectedConcernNameIndex > -1) {
          this.selected.concern.splice(selectedConcernIndex, 1);
          this.concernName.splice(selectedConcernNameIndex, 1);
        } else {
          this.selected.concern.push(subtag.id);
          this.concernName.push(subtag.name);
        }
      }
    },
    applyConcern() {
      this.userSelectingConcern = false;
      this.submit();
      this.showPillDropdown('concern');
    },
    async fetchBeautyTags() {
      return new Promise((resolve, reject) => {
        try {
          let codeParams = [];
          const productCategory = this.product.categories[0];
          if (productCategory && productCategory.name) {
            if (productCategory.name !== 'Hair Care') {
              codeParams.push('jenis-kulit');
              if (productCategory.name === 'Makeup') {
                codeParams = codeParams.concat(['undertone', 'warna-kulit']);
              } else if (['Skincare', 'Bath & Body'].includes(productCategory.name)) {
                codeParams.push('kondisi-kulit');
              }
            } else {
              codeParams = ['kondisi-rambut', 'jenis-rambut'];
            }
          }
          resolve(
            axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/tags?type=beauty-profile', {
              params: {
                filter: {
                  code: {
                    $in: codeParams,
                  },
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then((response) => {
        if (response.status === 200 && response.data && response.data.data) {
          const concerns = response.data.data;
          this.concernFilter = {
            title: 'All Concern',
            key: 'concern',
            list: concerns.map((concern) => {
              return {
                id: concern._id,
                name: concern.name,
                subtags: (concern.subtags || []).map((tag) => {
                  return {
                    id: tag._id,
                    name: tag.name,
                    image: tag.image,
                  };
                }),
                subtags_expanded: false,
              };
            }),
          };
        }
        this.pillsFilterLoading = false;
      });
    },
    isPillActive({ key }) {
      if (key === 'concern') {
        return !this.$SO.isEmptyObject(this.selected[key]) && !this.userSelectingConcern;
      } else {
        return !this.$SO.isEmptyObject(this.selected[key]);
      }
    },
    getSelectedFilterLabel({ key, list, title }) {
      if (['rating', 'age', 'combinations'].includes(key) && this.selected[key] && this.selected[key].length) {
        return list.find((ls) => ls.value === this.selected[key][0]).name;
      } else if (key === 'concern') {
        return !this.userSelectingConcern ? this.concernName.join(', ') : title;
      } else {
        return this.selected[key].name;
      }
    },
    isActiveMobileFilter(list) {
      const {
        selected,
        getOpenedFilterList: { key },
      } = this;
      if (key === 'sort') {
        return (!selected[key] && list.value === 'most_relevant') || selected[key].value === list.value;
      } else {
        return (key !== 'concern' && list.value === selected[key][0]) || selected[key].value;
      }
    },
    loginOtf() {
      this.$store.commit('modalAuth', 1);
    },
  },
};
</script>

<style lang="scss" scoped>
$lato_bold: 'Lato-Bold', sans-serif;
$lato_regular: 'Lato-Regular', sans-serif;

@mixin flexCenter() {
  display: flex;
  align-items: center;
}

@mixin listNone() {
  list-style: none;
  display: inline-flex;
  padding: 0;
}

@mixin fontHeader() {
  font-family: $lato_regular;
  font-size: 13px;
}

@mixin hideWebkitScrollbar() {
  &::-webkit-scrollbar {
    display: none;
  }
}

.hidden {
  display: none !important;
}

.rounded-image {
  border-radius: 50%;
  vertical-align: -5px;
}

.space {
  margin: 0 5px;
}

.filter-list {
  position: absolute;
  right: 16px;
  top: 75px;
  background: #ffffff;
  z-index: 12;
  width: 500px;
  padding: 25px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  &__item {
    padding: 16px 0 4px;
    border-top: 1px solid #e5e5e5;
    &:first-child {
      border-top: none;
      padding-top: 0px;
    }
    h4 {
      font-size: 13px;
      color: #231f20;
      letter-spacing: normal;
      font-family: $lato_bold;
      text-transform: uppercase;
    }
    ul {
      display: block !important;
      li {
        display: inline-block !important;
        border-radius: 25px !important;
        margin-bottom: 12px;
        padding: 6px 12px !important;
        ::v-deep .icon_star {
          color: #f384a7;
          height: 15px;
        }
        &.active {
          background: #f384a7 !important;
          border: 1px solid #f384a7 !important;
          ::v-deep .icon_star {
            color: #ffffff;
          }
        }
      }
      li.star-rating {
        display: inline-flex !important;
        align-items: center;
      }
    }
  }
  &__action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .reset {
      font-size: 14px;
      color: #da2a52;
      font-family: $lato_bold;
      cursor: pointer;
      margin: 0px;
    }
    .submit {
      font-family: $lato_bold;
      font-size: 13px;
      color: #ffffff;
      letter-spacing: normal;
      text-align: center;
      background: #da2a52;
      padding: 9px 16px;
      border-radius: 4px;
      margin: 0 0 0 20px;
      cursor: pointer;
      &.disabled {
        background: #e5e5e5;
        cursor: none;
      }
    }
  }
}

.filter-review {
  width: 100%;
  &__header {
    @include flexCenter;
    justify-content: space-between;
    position: relative;
    padding: 16px 16px 5px;
    ul {
      @include listNone;
      li {
        @include fontHeader;
        font-family: $lato_regular;
        padding: 10px 12px;
        background: #ffffff;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        cursor: pointer;
        margin-right: 12px;
        color: #8c8582;
        align-self: center;
        &.active {
          background: #da2a52;
          border: 1px solid #da2a52;
          color: #ffffff;
        }
      }
    }
    &__filter {
      padding: 10px 12px;
      background: #ffedf2;
      border-radius: 4px;
      cursor: pointer;
      span {
        @include fontHeader;
        color: #222222;
        margin-left: 6px;
        font-family: $lato_regular;
      }
    }
  }
  &__detail {
    @include flexCenter;
    background-image: url('/assets/img/combination-review-bg.svg');
    background-repeat: no-repeat;
    background-size: cover;
    padding: 12px 24px;
    border-radius: 4px;
    &__title {
      @include fontHeader;
      // font-family: $lato_bold;
      color: #8c8582;
      margin-right: 16px;
    }
    ul {
      @include listNone;
      margin: 0;
      display: inline-flex;
      padding: 0;
      flex-wrap: wrap;
      li {
        @include fontHeader;
        color: #8c8582;
        letter-spacing: 0;
        padding: 6px 12px;
        background: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 16px;
        margin-right: 8px;
        cursor: pointer;
        font-size: 12px;
        line-height: 15px;
        white-space: nowrap;
        margin-top: 4px;
        margin-bottom: 4px;
        position: relative;
        &.active {
          background: #f384a7;
          color: #ffffff;
          border: none;
        }
      }
      li.shade-only {
        // position: relative;
        padding: 0;
        margin-right: 15px;
        &.active {
          background: #ffffff;
        }
        &.active:before {
          content: '';
          position: absolute;
          width: 36px;
          height: 36px;
          margin-top: -5px;
          margin-left: -5px;
          border: solid 3px #f384a7;
          border-radius: 50%;
        }
      }
      button {
        border: none;
        border-radius: 50%;
      }
    }
  }
  &__pills {
    padding: 0 16px;
    margin-top: 18px;
    > ul {
      @include flexCenter();
      margin: 0;
      > li {
        background: #ffffff;
        font-family: $lato_regular;
        font-size: 12px;
        color: #222222;
        letter-spacing: 0;
        position: relative;
        &:not(:last-child) {
          @media (max-width: 991px) {
            margin-right: 0;
          }
          margin-right: 8px;
        }
        &.placeholder {
          border-radius: 15px;
        }
        @media (max-width: 991px) {
          margin-left: 8px;
          &:first-child {
            margin-left: 16px;
          }
          &:last-child {
            margin-right: 16px;
          }
        }
      }
      @media (max-width: 991px) {
        overflow-x: auto;
        > li {
          min-width: max-content;
        }
        @include hideWebkitScrollbar();
      }
    }
    &--pill {
      @include flexCenter();
      padding: 6px 10px;
      cursor: pointer;
      border: 1px solid #222222;
      border-radius: 15px;
      span {
        line-height: 15px;
        margin-right: 4px;
      }
      &.active {
        background: #f384a7;
        border: 1px solid #f384a7;
        border-radius: 12.5px;
        color: #fff;
      }
    }
    &--dropdown {
      position: absolute;
      margin-top: 4px;
      background: #ffffff;
      border: 1px solid #f3f3f3;
      box-shadow: 2px 5px 6px 1px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      z-index: 1;
      width: max-content;
      padding: 10px 0 7px;
      li {
        p {
          margin: 0;
          font-family: $lato_regular;
          font-size: 13px;
          color: #231f20;
          text-align: left;
          padding: 10px 24px;
          line-height: 16px;
          &:not(.has-subtags) {
            cursor: pointer;
            &:hover {
              background-color: #fff6f6;
            }
          }
          &.has-subtags {
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            img {
              transform: rotate(0deg);
              transition: transform 0.5s ease-in-out;
            }
            &.expanded {
              img {
                transform: rotate(180deg);
              }
            }
          }
        }
        .rate-star--uniform {
          padding: 12px 0;
          margin: 0 24px;
          .icon_star::before {
            position: relative;
            top: -0.5px;
            margin-left: 1px;
            color: #e5e5e5;
          }
        }
      }
      .subtags {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.5s ease-in-out;
        &.expanded {
          max-height: 800px;
        }
        p {
          @include flexCenter();
          padding: 0 24px !important;
          input[type='checkbox'] {
            margin-top: 0;
            margin-right: 8px;
            height: 16px;
            width: 16px;
            &:after {
              height: 16px;
              width: 16px;
              border: 1px solid #e5e5e5;
              border-radius: 4px;
              top: 0;
            }
            &:checked::after {
              height: 16px;
              width: 16px;
              border: none;
            }
          }
          label {
            margin: 0;
            padding: 6px 0;
            flex: 1;
          }
        }
      }
      .apply-button {
        padding: 0 24px;
        margin: 16px 0 10px;
        button {
          height: 32px;
          line-height: 18px;
          width: 100%;
        }
      }
    }
    + .filter-review__personalized {
      margin-top: 16px;
      @media (max-width: 991px) {
        margin-top: 12px;
        margin-bottom: 12px;
      }
    }
    .shade-combination {
      @include flexCenter();
    }
    &::v-deep {
      .shade-combination--image {
        height: 16px;
        width: 16px;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
    @media (max-width: 991px) {
      margin-top: 12px;
      padding: 0;
      &--pill {
        height: 25px;
        background: #f8f8f8;
      }
    }
  }
  &__personalized {
    &--login-and-complete-bp {
      padding: 12px 24px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      background-image: url('/assets/img/review-personalized-bg1.svg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top right;
      flex-direction: column;
      @media (max-width: 991px) {
        display: block;
        background: none;
        padding: 0 16px;
      }
    }
    &__edit-link {
      font-family: $lato_bold;
      font-size: 13px;
      color: #222222;
      letter-spacing: 0;
      line-height: 18px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 8px;
      color: $greynew;
      p {
        margin: 0;
        a {
          color: #da2a52;
          font-family: $lato_bold;
        }
        &:first-child {
          font-family: $lato_regular;
        }
      }
      &--mobile {
        margin-top: 12px;
        padding: 8px 12px;
        font-family: $lato_regular;
        font-size: 12px;
        color: #222222;
        letter-spacing: 0;
        line-height: 20px;
        background-image: url('/assets/img/review-personalized-bg1-mobile.svg');
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 4px;
        p {
          margin: 0;
          span {
            font-family: $lato_bold;
          }
          a {
            color: #da2a52;
            font-family: $lato_bold;
          }
        }
      }
    }
    &--not-complete-bp {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 9px;
      padding-bottom: 9px;
      background-image: url('/assets/img/review-personalized-bg2-desktop.svg');
      background-repeat: no-repeat;
      background-size: 100%;
      font-family: $lato_regular;
      font-size: 12px;
      color: #222222;
      letter-spacing: 0;
      line-height: 20px;
      text-align: center;
      a {
        color: #da2a52;
        font-family: $lato_bold;
      }
      p {
        margin: 0;
      }
      strong {
        margin-left: 16px;
        display: flex;
        align-items: center;
        gap: 4px;
      }
      @media (max-width: 991px) {
        text-align: left;
        background-image: url('/assets/img/review-personalized-bg2-mobile.svg');
        background-size: cover;
        margin-left: 16px;
        margin-right: 16px;
        padding: 8px 12px;
      }
    }
    &--trusted-review {
      margin: 20px 20px 0;
      font-family: $lato_regular;
      font-size: 14px;
      color: #222222;
      letter-spacing: 0;
      line-height: 22px;
      display: flex;
      gap: 5px;
      margin-bottom: 8px;
      border-bottom: dashed 1px #e5e5e5;
      span {
        font-family: $lato_bold;
      }
      a {
        font: 12px/15px $lato_bold;
        color: #da2a52;
        letter-spacing: normal;
        cursor: pointer;
      }
      img {
        position: relative;
        top: 4px;
      }
      @media (max-width: 991px) {
        font-size: 12px;
        line-height: 16px;
        display: block;
        margin-bottom: 12px;
        padding-bottom: 36px;
        position: relative;
        p {
          display: inline;
          margin: 0;
        }
        img {
          top: -2px;
        }
        a {
          position: absolute;
          right: 0;
          bottom: 8px;
        }
      }
    }
  }
}

.filter-review {
  &__header.unwrapped {
    padding: 0 24px;
    box-shadow: inset 0 -2px 0 #e5e5e5;
    @media (max-width: 991px) {
      padding: 0;
    }
    ul {
      margin-bottom: 0;
      li {
        font-family: $lato_bold;
        font-size: 13px;
        color: #8c8582;
        line-height: 15px;
        padding: 17px 0;
        margin-right: 32px;
        border: none;
        background-color: transparent;
        @include flexCenter;
        img {
          margin-right: 8px;
        }
        &.active {
          border-bottom: 2px solid #da2a52;
          color: #231f20;
          background-color: transparent;
          border-radius: 0;
        }
        @media (max-width: 991px) {
          margin: 0 16px;
          padding: 16px 0;
        }
      }
      @media (max-width: 991px) {
        @include hideWebkitScrollbar();
        li {
          font-size: 11px;
        }
      }
    }
  }
}

#pills-dropdown-mobile::v-deep {
  .modal-dialog {
    width: 100%;
    margin: 0;
    align-self: flex-end;
    height: max-content;
    max-height: 585px;
    overflow-y: auto;
    border-radius: 18px 18px 0 0;
    .modal-content {
      .modal-header {
        padding: 0;
        .rectangle-top {
          background: #efefef;
          border-radius: 8px;
          height: 3px;
          width: 38px;
          margin: 8px auto;
        }
        .modal-heading {
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0;
          &--title {
            margin-top: 0;
            margin-bottom: 0;
            font-family: $lato_bold;
            font-size: 14px;
            color: #231f20;
            letter-spacing: normal;
            line-height: 18px;
          }
          &--close {
            position: initial;
            margin-top: 0;
            line-height: 0;
          }
        }
      }
      .modal-body {
        padding: 0;
        .pills-dropdown-mobile--list {
          margin-bottom: 24px;
          > li {
            padding: 12px 16px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.87);
            text-align: left;
            line-height: 24px;
            &.active {
              @include flexCenter();
              justify-content: space-between;
              p {
                font-family: $lato_bold;
              }
              &::after {
                content: url('/assets/img/icon-check-success-pink.svg');
                line-height: 0;
              }
            }
            &.has-subtags {
              padding: 0;
              margin-bottom: 2px;
            }
            &.apply-button {
              padding: 24px 16px;
              margin-bottom: -24px;
              button {
                width: 100%;
              }
            }
            &:not(.has-subtags) {
              cursor: pointer;
            }
            p {
              margin-top: 0;
              margin-bottom: 0;
              font-family: $lato_regular;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.87);
              text-align: left;
              line-height: 24px;
              &.has-subtags {
                font-family: $lato_bold;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 16px;
                background-color: #f5f5f5;
                cursor: pointer;
                img {
                  transform: rotate(0deg);
                  transition: transform 1s ease-in-out;
                }
                &.expanded {
                  img {
                    transform: rotate(180deg);
                  }
                }
              }
            }
            .rate-star--uniform {
              padding: 0;
              margin: 0;
              width: auto;
              span {
                width: 18px;
                height: 16px;
                background-size: 18px 16px;
                &::before {
                  width: 18px;
                  height: 16px;
                  background-size: 18px 16px;
                }
              }
              .icon_star::before {
                position: relative;
                top: -0.5px;
                margin-left: 1px;
                color: #e5e5e5;
              }
            }
            .subtags {
              max-height: 0;
              overflow: hidden;
              transition: max-height 1s ease-in-out;
              &.expanded {
                max-height: 800px;
              }
              p {
                @include flexCenter();
                padding: 0 16px 0 32px !important;
                margin-top: 16px;
                margin-bottom: 16px;
                input[type='checkbox'] {
                  margin-top: 0;
                  height: 16px;
                  width: 16px;
                  cursor: pointer;
                  &:after {
                    height: 16px;
                    width: 16px;
                    border: 1px solid #e5e5e5;
                    border-radius: 4px;
                    top: 0;
                  }
                  &:checked::after {
                    height: 16px;
                    width: 16px;
                    border: none;
                  }
                }
                label {
                  cursor: pointer;
                  margin: 0;
                  padding: 0;
                  flex: 1;
                }
              }
            }
            .shade-combination {
              @include flexCenter();
              img {
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
            &::v-deep {
              .shade-combination--image {
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .filter-list {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 99999;
    top: 0;
    left: 0;
    padding: 0;
    overflow-y: auto;
    &__header {
      position: sticky;
      top: 0;
      background: #ffffff;
      padding: 16px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      p {
        margin: 0;
        font-family: $lato_bold;
        font-size: 14px;
      }
      &__left {
        color: #231f20;
        letter-spacing: normal;
        text-transform: uppercase;
        span {
          vertical-align: middle;
          margin-left: 24px;
        }
        svg {
          vertical-align: middle;
        }
      }
      &__right {
        color: #da2a52;
      }
    }
    &__item {
      border-top-width: 8px;
      border-color: #f8f8f8;
      margin: 0 -16px;
      padding: 16px 16px 4px;
    }
    &__wrap,
    &__action {
      padding: 0 16px 16px;
    }
    &__action > .submit {
      width: 100%;
      margin: 0;
    }
  }
  .filter-review {
    &__header {
      padding: 12px 16px;
      border-top: 8px solid #f8f8f8;
      ul {
        overflow-x: auto;
        overflow-y: hidden;
        //padding: 10px 5px;
        li {
          min-width: max-content;
          width: auto;
          padding: 8px 12px;
          &.filter-button {
            background-color: #ffedf2;
          }
        }
      }
    }
    &__detail {
      padding: 12px 16px;
      background-image: url('/assets/img/combination-review-bg-mobile.svg');
      ul {
        overflow-x: auto;
        overflow-y: hidden;
        display: flex;
        //padding: 10px 5px;
        li {
          min-width: max-content;
          width: auto;
        }
        li.shade-only {
          margin: 8px 8px 8px 0;
          &:first-child {
            margin: 8px;
          }
          &.active:before {
            width: calc(100% + 10px);
            top: -5px;
            left: -5px;
          }
        }
        li.shade-only.active {
          &:first-child {
            margin-right: 12px;
          }
        }
      }
    }
  }
  .hide {
    opacity: 0;
    transition: opacity 1s linear;
  }
}
.filter-review__pills--pill {
  max-width: 200px;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
